import { EntityBadge, EntityBadgeProps } from "src/components/badges/entity";

/**
 * The properties for {@link DeviceGroupBadge}
 */
export type DeviceGroupBadgeProps = Omit<EntityBadgeProps, "entity" | "prefix" | "href" | "params"> & {
    /**
     * The device group this badge is for
     *
     * The type is intentionally not from the generated sdk
     * to support as many caller as possible
     */
    deviceGroup: { uuid: string; name: string; description?: string };
};

/**
 * A badge labeled `device-group:name` linking to the device group's page
 */
export function DeviceGroupBadge(props: DeviceGroupBadgeProps) {
    const { deviceGroup, ...rest } = props;

    return (
        <EntityBadge
            {...rest}
            entity={deviceGroup}
            prefix={"device-group"}
            href={"/a/devicegroups/$deviceGroupId/associated"}
            params={{ deviceGroupId: deviceGroup.uuid }}
        />
    );
}
